import React, {useEffect, useRef, useState} from "react";
import {Box, Button, Divider, Typography, useMediaQuery} from "@mui/material";
import {FlyerPagesTocEntriesDto, ItemsListMenuDto} from "../../dtos";
import {useDispatch} from "react-redux";
import {deleteToc} from "../../store/actionCreators/tocForPagesActionsCreator";
import {ReactComponent as MenuOnHover} from "../../assets/promos&items/menu_on_hover.svg";
import {
    MenuForPromotion
} from "../editor/promos/leftMenu/LeftMenuContent/LeftMenuContentElement/MenuForPromotions/menuForPromotions";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {convertPagesRangeToString} from "../../globals/globFunctions";

interface Props {
    item: FlyerPagesTocEntriesDto;
    openPopup: (item: FlyerPagesTocEntriesDto) => void;
}

export const FlippingFlyerToCTabItem: React.FC<Props> = ({
                                                             item,
                                                             openPopup
                                                         }) => {
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const anchorRefForPageToCMenu = useRef(null);
    const dispatch = useDispatch();
    const isXs = useMediaQuery(`(max-width:599px)`);
    const [isHover, setIsHover] = useState<boolean>(false);
    const [isOpenedPageToCMenu, setOpenPageToCMenu] = useState(false);
    const [pageStringRange, setPageStringRange] = useState<string>('');
    const prevOpenPageToCMenu = useRef(isOpenedPageToCMenu);

    useEffect(() => {
        const pagesRangeInString = convertPagesRangeToString(item.pageRange);
        setPageStringRange(pagesRangeInString);
        return () => {
            setPageStringRange('')
        };
    }, [item.pageRange]);


    const onMouseEnter = () => {
        setIsHover(true)
    }
    const onMouseLeave = () => {
        setIsHover(false);
        setOpenPageToCMenu(false);
    }

    const deleteTocCaption = (e: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>) => {
        e.preventDefault();
        dispatch(deleteToc(item.id, flyerDetailsState));
    }

    const editTocCaption = (e: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>) => {
        openPopup(item);
    }

    const handleToggleForPageToC = () => {
        setOpenPageToCMenu((prevOpen) => !prevOpen);
    };

    const clickMenuDataForPageToC: ItemsListMenuDto = {
        setOpen: setOpenPageToCMenu,
        prevOpen: prevOpenPageToCMenu,
        open: isOpenedPageToCMenu,
        anchorRef: anchorRefForPageToCMenu,
    };


    return (
        // <Draggable key={item.id} draggableId={item.id!.toString()} index={index}>
        //     {(provided, snapshot) => (
                <Box
                    key={item.id}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    // ref={provided.innerRef}
                    // {...provided.draggableProps}
                    sx={{
                        userSelect: "none",
                        border: "1px solid transparent",
                        // padding: isXs ? "4px 2px 4px 6px" : "4px 2px 4px 16px",
                        position: "relative",
                        // change background colour if dragging
                        backgroundColor: isHover && !isXs ? "#dddddd" : "#FFFFFF",
                        // background: snapshot.isDragging ? "#dddddd" : "white",
                        // opacity: snapshot.isDragging ? 0.5 : 1,
                        display: "flex",
                        flexFlow: "row",
                        alignItems: "center",
                    }}
                >
{/*
                    <Box
                        //{...provided.dragHandleProps}
                        sx={{
                            position: `absolute`,
                            top: `50%`,
                            transform: "translateY(-50%)",
                            left: `2px`,
                            display: "flex"
                        }}>
                        {
                            (isHover || snapshot.isDragging) && !isXs &&
                            <DragIcon style={{
                                width: "100%",
                                height: "100%",
                                cursor: `move`,
                            }}/>
                        }
                    </Box>
*/}
                    <Box
                        sx={{
                            flex: "1 1 auto",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "4px",
                        }}
                        //{...(isXs && {...provided.dragHandleProps})}

                    >
                        <Typography>
                            {item.caption}
                        </Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem sx={{
                        width: `1px`,
                        backgroundColor: "#FFFFFF",
                        borderWidth: "0"
                    }}/>
                    <Box sx={{
                        minWidth: isXs ? "30%" : "30%",
                        width: isXs ? "30%" : "30%",
                        display: "flex",
                        flexFlow: "row",
                        padding: "4px 16px",
                        // columnGap: "16%",
                        // maxHeight: "20px",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            flex: "1 1 auto",
                        }}>
                            <Typography textAlign={"center"} width={"100%"}>
                                {pageStringRange}
                            </Typography>
                        </Box>
                        {
                            (isHover || isXs) &&
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    right: "0px",
                                }}
                            >
                                <Button
                                    sx={{
                                        width: "20px",
                                        height: "20px",
                                    }}
                                    // disableRipple={true}
                                    ref={anchorRefForPageToCMenu}
                                    aria-controls={
                                        isOpenedPageToCMenu
                                            ? "menu-list-grow"
                                            : undefined
                                    }
                                    aria-haspopup="true"
                                    onClick={handleToggleForPageToC}
                                >
                                    <MenuOnHover/>
                                </Button>
                                <MenuForPromotion
                                    list={clickMenuDataForPageToC}
                                    editTocCaption={editTocCaption}
                                    deleteTocCaption={deleteTocCaption}
                                    infoForMenu={`menuForPageToC`}
                                />
                            </Box>
                        }

{/*
                        <Box sx={{
                            display: "flex",
                            flexFlow: "row",
                            width: "60%",
                            minWidth: "60%",
                            justifyContent: "space-around",
                            alignItems: "center"
                        }}>
                            <Button
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    padding: "4px",
                                }}
                                onClick={editTocCaption}
                            >
                                <EditNoFillIcon style={{maxWidth: "100%", maxHeight: "100%"}}/>
                            </Button>
                            <Button
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    padding: "4px",
                                }}
                                onClick={deleteTocCaption}
                            >
                                <DeleteNoFillIcon style={{maxWidth: "100%", maxHeight: "100%"}}/>
                            </Button>
                        </Box>
*/}
                    </Box>
                </Box>
        //     )}
        // </Draggable>
    )
}